import { createAsyncThunk } from "@reduxjs/toolkit";
import apiCall from "../AuthorizedApi";

export const changePhoneNumberOtpAPI = createAsyncThunk(
    'auth/changePhoneNumberOtpAPI',
    async (credentials: { phone_number: string, country_code: string }, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'POST',
                url: '/account/sendotp_v2/',
                data: credentials
            });
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const changePhoneNumberAPI = createAsyncThunk(
    'auth/changePhoneNumberAPI',
    async (credentials: { new_phone_number: string, new_country_code: string, otp: string, orderId: string }, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'PUT',
                url: '/account/update-phone/',
                data: credentials
            });
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);


export const getBusinessDetailsAPI = createAsyncThunk(
    'auth/getBusinessDetailsAPI',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: '/account/business-detail/',
            });
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const updateBusinessDetailsAPI = createAsyncThunk(
    'auth/updateBusinessDetailsAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'PUT',
                url: '/account/business-detail/',
                data
            });
            return response.data || response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const updateUserDetailsAPI = createAsyncThunk(
    'auth/updateUserDetailsAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'PUT',
                url: '/account/update-userdetail/',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                data
            });
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

/** Persist studio-owner consent to view redeem-user contact info (once per account). */
export const acceptRedeemContactTermsAPI = createAsyncThunk(
    'auth/acceptRedeemContactTermsAPI',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'POST',
                url: '/account/show-redeem-user-mobile/',
                data: { show_redeem_user_mobile: true },
            });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data ?? error.message);
        }
    }
);

/** Persist user acceptance of dashboard terms & conditions */
export const acceptDashboardTermsAPI = createAsyncThunk(
    'auth/acceptDashboardTermsAPI',
    async (payload: { accepted?: boolean } = {}, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'POST',
                url: '/account/studio/dashboard-terms/accept/',
                data: {
                    accepted: payload?.accepted !== undefined ? payload.accepted : true,
                },
            });
            return response.data ?? response;
        } catch (error: any) {
            return rejectWithValue(error.response?.data ?? error.message);
        }
    }
);
export const verifyEmailLinkAPI = createAsyncThunk(
    'auth/verifyEmailLinkAPI',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'POST',
                url: '/account/user/send-verify-token/',
                data
            });
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);


export const getUserActivePlanAPI = createAsyncThunk(
    'auth/getUserActivePlanAPI',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: '/plans/current-plan/',
            });
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);
